module.exports = __webpack_public_path__ + "static/media/step5.4ba882b4.png";